module.exports = __webpack_public_path__ + "media/images/cabezera_mail-a736bf80c9782d1cf01ddbdaf2b367e6.png";